import styled from "styled-components";

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/aside

export const Aside = styled.aside`
  display: flex;
`;
